import classnames from 'classnames';
import React, { PropTypes } from 'react';

const CurrentUser = React.createClass({
    render: function () {
        return (
            <div className="pure-menu pure-menu-horizontal">
            </div>
        );
    }
});

const PageLayout = React.createClass({

    render: function () {
        const pageClasses = classnames('sc-page');

        return (
            <div className={pageClasses}>
                {this.props.children}
            </div>
        );
    }
});

PageLayout.propTypes = {
    mode: PropTypes.string.isRequired
};

export default PageLayout;



// WEBPACK FOOTER //
// ./src/components/common/PageLayout/index.jsx